/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './paediatric-params.reducer';

export const PaediatricParamsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const paediatricParamsEntity = useAppSelector(state => state.paediatricParams.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="paediatricParamsDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.paediatricParams.detail.title">PaediatricParams</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.paediatricParams.id">Id</Translate>
            </span>
          </dt>
          <dd>{paediatricParamsEntity.id}</dd>
          <dt>
            <span id="headCircumference">
              <Translate contentKey="tinyMedicRestApp.paediatricParams.headCircumference">Head Circumference</Translate>
            </span>
          </dt>
          <dd>{paediatricParamsEntity.headCircumference}</dd>
          <dt>
            <span id="midArmCircumference">
              <Translate contentKey="tinyMedicRestApp.paediatricParams.midArmCircumference">Mid Arm Circumference</Translate>
            </span>
          </dt>
          <dd>{paediatricParamsEntity.midArmCircumference}</dd>
          <dt>
            <span id="thumbGirth">
              <Translate contentKey="tinyMedicRestApp.paediatricParams.thumbGirth">Thumb Girth</Translate>
            </span>
          </dt>
          <dd>{paediatricParamsEntity.thumbGirth}</dd>
          <dt>
            <span id="thumbLength">
              <Translate contentKey="tinyMedicRestApp.paediatricParams.thumbLength">Thumb Length</Translate>
            </span>
          </dt>
          <dd>{paediatricParamsEntity.thumbLength}</dd>
          <dt>
            <span id="thumbNailWidth">
              <Translate contentKey="tinyMedicRestApp.paediatricParams.thumbNailWidth">Thumb Nail Width</Translate>
            </span>
          </dt>
          <dd>{paediatricParamsEntity.thumbNailWidth}</dd>
          <dt>
            <span id="subscapularSkinfold">
              <Translate contentKey="tinyMedicRestApp.paediatricParams.subscapularSkinfold">Subscapular Skinfold</Translate>
            </span>
          </dt>
          <dd>{paediatricParamsEntity.subscapularSkinfold}</dd>
          <dt>
            <span id="tricepsSkinfold">
              <Translate contentKey="tinyMedicRestApp.paediatricParams.tricepsSkinfold">Triceps Skinfold</Translate>
            </span>
          </dt>
          <dd>{paediatricParamsEntity.tricepsSkinfold}</dd>
          <dt>
            <span id="notes">
              <Translate contentKey="tinyMedicRestApp.paediatricParams.notes">Notes</Translate>
            </span>
          </dt>
          <dd>{paediatricParamsEntity.notes}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.paediatricParams.active">Active</Translate>
            </span>
          </dt>
          <dd>{paediatricParamsEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.paediatricParams.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{paediatricParamsEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.paediatricParams.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{paediatricParamsEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.paediatricParams.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{paediatricParamsEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.paediatricParams.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{paediatricParamsEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paediatricParams.weight">Weight</Translate>
          </dt>
          <dd>{paediatricParamsEntity.weight ? paediatricParamsEntity.weight.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.paediatricParams.patient">Patient</Translate>
          </dt>
          <dd>{paediatricParamsEntity.patient ? paediatricParamsEntity.patient.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/paediatric-params" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/paediatric-params/${paediatricParamsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PaediatricParamsDetail;
